export default __webpack_public_path__ + "static/media/whm.f901d5c2.jpg";